import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../common/config";

export const matrixService = createApi({
  reducerPath: "matrix",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api",
  }),
  endpoints: (builder) => ({
    getMatrix: builder.query({
      query: () => ({
        url: `/users/getmatrix`,
        method: "GET",
      }),
    }),
  }),
});
export const { useGetMatrixQuery } = matrixService;
